<template>
  <div id="app">
    <tab />
    <!-- <div id="nav"> -->
    <!-- <router-link to="/">Home</router-link> | -->
    <!-- <router-link to="/about">About</router-link> -->
    <!-- </div> -->
    <router-view />
    <div
      @click="scrollTop"
      class="cursor-pointer fixed f1eee6-bg p10"
      style="right: 0; top: 50%"
    >
      <img width="25" src="@/assets/btn/up.png" alt="">
    </div>
  </div>
</template>
<script>
import tab from "./components/Tab.vue";

export default {
  components: {
    tab,
  },
  data() {
    return {};
  },
  methods: {
    scrollTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    // console.log(this.$Datas.floorplan.floorplan_1.unit_1.unit_name);
  },
};
</script>



<style lang="less">
html,
body,
#app {
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0px;
  padding: 0px;
  /* overflow: hidden; */
  color: #f1eee6;
}
#app {
  font-family: Montserrat, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

::-webkit-scrollbar {
  width: 5px;
  height: 3px;
  background-color: rgb(83, 83, 83);
}
::-webkit-scrollbar:hover {
  /* width: 5px !important; */
}
::-webkit-scrollbar-track {
  background: linear-gradient(to right, #f5f5f5 40%, #949494, #fafafa 60%);
}

::-webkit-scrollbar-thumb {
  height: 5px !important;
  padding: 10px;
  background-color: rgb(83, 83, 83);
}
/* ::-webkit-scrollbar-thumb:hover {
  background-color: rgb(83, 83, 83);
  width: 30px !important;

} */
/* ::-webkit-scrollbar-thumb:active {
  background-color: rgb(83, 83, 83);
} */
</style>
